import { Controller } from "@hotwired/stimulus"
import { post, get } from '@rails/request.js'
import { emitContentMediaSelected } from "../utils/events"

export default class extends Controller {

  static values = {
    args: Object, // arguments à renvoyer avec l'event pour l'identifier chez le récepteur
    origin: String
  }

  select(event) {
    const { id, action, editTransformedUrl, editId, url, ...file } = event.currentTarget.dataset;
    const edit = editId ? { id: editId, transformedUrl: editTransformedUrl } : null
    const contentMedium = { id, serialized_file: file, edit, url: url, thumbnail_url: url, format: file.resource_type, }
    emitContentMediaSelected(contentMedium, this.originValue, this.argsValue);
    window.closeDialog(this.originValue);
  }

  async selectExternalSource(event) {
    const { url, thumbnailUrl, format } = event.currentTarget.dataset;
    const body = JSON.stringify({ content_medium: { remote_medium_url: url } })
    // en attendant d'en finir avec les provisional_id, on veut des int bien random
    const uuid = Math.floor(Math.random() * 1000000000000) + 1;
    emitContentMediaSelected({ url: thumbnailUrl, format }, this.originValue, { ...this.argsValue, uuid })
    window.closeDialog(this.originValue);
    const res = await post('/content_media', { body, headers: { 'Accept': 'application/json' } })
    const { content_medium } = await res.json
    emitContentMediaSelected(content_medium, this.originValue, { ...this.argsValue, uuid })
  }

}
